import {
  EllipsisIcon,
  ExternalLinkIcon,
  PencilIcon,
  Trash2Icon,
} from "lucide-react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { FRONTEND_ROUTES } from "@/constants"
import { usePermission } from "@/contexts/permission"
import { PermissionsRolesEnum } from "@/enums"

interface CustomerCellActionsProps {
  customer: Customer
}

export const CustomerCellActions = ({
  customer,
}: CustomerCellActionsProps) => {
  const { t } = useTranslation()
  const { hasPermission } = usePermission()

  const canWrite = hasPermission([
    PermissionsRolesEnum.CUSTOMERS_WRITE,
  ])

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex justify-end">
          <Button
            size="icon"
            variant="ghost"
            className="shadow-none"
            aria-label="Actions"
          >
            <EllipsisIcon
              size={16}
              strokeWidth={2}
              aria-hidden="true"
            />
          </Button>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="space-y-1"
      >
        <DropdownMenuItem asChild>
          <Button
            variant="ghost"
            size={"sm"}
            className="w-full cursor-pointer justify-start"
            asChild
          >
            <Link
              to={`${FRONTEND_ROUTES.CUSTOMERS.href}/details/${customer.id}`}
            >
              <ExternalLinkIcon
                size={16}
                className="mr-2"
              />
              {t("pages.customers.actions.details")}
            </Link>
          </Button>
        </DropdownMenuItem>
        {canWrite && (
          <>
            <DropdownMenuItem asChild>
              <Button
                variant="ghost"
                size={"sm"}
                className="w-full cursor-pointer justify-start"
                asChild
              >
                <Link
                  to={`${FRONTEND_ROUTES.CUSTOMERS.href}/edit/${customer.id}`}
                >
                  <PencilIcon size={16} className="mr-2" />
                  {t("pages.customers.actions.edit")}
                </Link>
              </Button>
            </DropdownMenuItem>
            <DropdownMenuItem
              asChild
              className="text-destructive hover:text-destructive"
            >
              <Button
                variant="ghost"
                size={"sm"}
                className="w-full cursor-pointer justify-start !text-destructive"
              >
                <Trash2Icon size={16} className="mr-2" />
                {t("pages.customers.actions.delete")}
              </Button>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
